(function ($) {

	  Drupal.behaviors.applicationFormAchievements = {
				attach: function (context) {
					Drupal.behaviors.applicationFormAchievementsCreator(context);

					$(".artistic_upload.formField-achievements").each(function(){
						var fileName = $(this).children(".artistic_upload_data").attr("data-work-filename");
						var fileExt = fileName.split(".").pop().toLowerCase(); //.substring(0,3);
						if(fileExt.indexOf("?") >= 0){
							fileExt = fileExt.substring(0,fileExt.indexOf("?"));
						}

						var filePath = $(this).children(".artistic_upload_data").attr("data-work-file");

						$(this).children(".formField-photoLoader-photo").removeClass("fallback");
						$(this).children(".formField-photoLoader-photo").html("");

						Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormAchievements() fileExt:" + fileExt);

						if(fileExt != "jpg" && fileExt != "png" && fileExt != "jpeg"){

							Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormAchievements() show fallback image!");

							var fallback = $(".formField-photoLoader-photo").attr("data-fallback-image");
							$(this).children(".formField-photoLoader-photo").css("background-image", "url('" + fallback + "')");
							$(".formField-photoLoader-photo").addClass("fallback");
							$(this).children(".formField-photoLoader-photo").html(fileExt);
						}

						$(this).children(".formField-photoLoader-photo").attr("href", filePath);
					});

					$(".achievent-delete-button").each(function(){

						//disable delete button
						$(this).children("button").prop("disabled",true);

						$(this).click(function(){
							$(".preloader").show();

							//unbind this
							$(this).unbind();

							//submit delete with timeout for safari
							setTimeout(function(buttonid){

								//enable delete-form-button
								$("#" + buttonid).prop("disabled",false);

								//click delete-form-button
								$("#" + buttonid).click();

							}, 500, $(this).children("button").attr("id"));

						});
					});

					if(typeof applicationFormMandatoryFieldData !== 'undefined') {
						initMandatoryFields();
						initFormValidation();
					}

					function initMandatoryFields(){
						var mandatoryFields = applicationFormMandatoryFieldData.fields;

						for (var i = 0; i < mandatoryFields.length; i++) {
							var field = mandatoryFields[i];
							var $element = $("#" + field.id);

							if(field.mandatory == "true"){
								$element.closest(".formField").addClass("formField-mandatory");
							}

							$element.closest(".formField").addClass("formField-hasErrorHandling");

							for(var j=0; j < field.errors.length; j++){
								var err = field.errors[j];
								var $errorMessage = $("<div class='formField-error-message " + err.id + "'></div>");
								$errorMessage.html(err.text);
								$element.closest(".formField").append($errorMessage);
							}
						}
					}

					function initFormValidation(){

						//////////////////////////////////////////
						// TEST BUTTON //////////////////////////

						$("#appliationFormTestValidationButton").hide();
						/*
						$("#appliationFormTestValidationButton").css("opacity", "0.5");
						$("#appliationFormTestValidationButton").click(function(event){
							event.preventDefault();

							$(".preloader").show();

							var validationResult1 = Drupal.behaviors.formValidation.validateFields($("#application-form"), false);
							var validationResult2 = validateSpecialFields($("#application-form"), false);

							Drupal.behaviors.functions.consolog("#application-form TEST submit validationResult1:" + validationResult1);
							Drupal.behaviors.functions.consolog("#application-form TEST submit validationResult2:" + validationResult2);

							if(validationResult1 && validationResult2){
								Drupal.behaviors.functions.consolog("submit form...");
								//submit form...
							}
							else{
								Drupal.behaviors.functions.consolog("scroll to error...");
								//scroll to first error
								$('html, body').animate({
									scrollTop: $(".formField-error").offset().top-150
								}, 500);

								$(".preloader").hide();
							}
						});
						*/

						// TEST BUTTON //////////////////////////
						////////////////////////////////////////

						//modal group create
						$("#edit-create").prop("disabled", true);
						$("#appliationFormGroupCreateButton").click(function(event){
							event.preventDefault();
							$(".preloader").show();

							setTimeout(function(){
								if(Drupal.behaviors.formValidation.validateFields($("#edit-create").closest(".modal-content"), true)){
									$("#edit-create").prop("disabled", false);
									$("#edit-create").click();
								}
								else{
									$(".preloader").hide();
								}
							}, 500)
						});
						$("#modal_group_create").on('hidden.bs.modal', function (e) {
							$(this).find(".formField").removeClass("formField-error");
							$(this).find(".formField-error-message ").hide();
						});

						//modal artistic works
						$("#savebutton_edit-submit--2").prop('onclick',null).off('click');
						$("#savebutton_edit-submit--2").unbind().click(function(event){
							Drupal.behaviors.functions.consolog("CLICK #edit-submit--2 button");
							event.preventDefault();
							$(".preloader").show();

							//set timeout to show preloader on safari
							setTimeout(function(){
								if(Drupal.behaviors.formValidation.validateFields($("#savebutton_edit-submit--2").closest(".modal-content"), true)){
									//remove file upload input fields
									$("#application-form").find("input[type=file]").remove();

									//submit form
									$("#edit-submit--2").click();
								}
								else{
									//found validation error
									$(".preloader").hide();
								}
							}, 500);

						});
						$("#artistic_works_create").on('hidden.bs.modal', function (e) {
							Drupal.behaviors.formValidation.resetUploadField($(this));
						});

						//modal qualifiations works
						$("#savebutton_edit-submit--3").prop('onclick',null).off('click');
						$("#savebutton_edit-submit--3").unbind().click(function(event){
							Drupal.behaviors.functions.consolog("CLICK #edit-submit--3 button");
							event.preventDefault();
							$(".preloader").show();

							//set timeout to show preloader on safari
							setTimeout(function(){
								if(Drupal.behaviors.formValidation.validateFields($("#savebutton_edit-submit--3").closest(".modal-content"), true)){
									//submit form
									$("#edit-submit--3").click();
								}
								else{
									//found validation error
									$(".preloader").hide();
								}
							}, 500);
						});
						$("#qualifications_awards_create").on('hidden.bs.modal', function (e) {
							$(this).find(".formField").removeClass("formField-error");
							$(this).find(".formField-error-message ").hide();
						});

						//modal appearance works
						$("#savebutton_edit-submit--4").prop('onclick',null).off('click');
						$("#savebutton_edit-submit--4").unbind().click(function(event){
							Drupal.behaviors.functions.consolog("CLICK #edit-submit--4 button");
							event.preventDefault();
							$(".preloader").show();

							//set timeout to show preloader on safari
							setTimeout(function(){
								if(Drupal.behaviors.formValidation.validateFields($("#savebutton_edit-submit--4").closest(".modal-content"), true)){
									//submit form
									$("#edit-submit--4").click();
								}
								else{
									//found validation error
									$(".preloader").hide();
								}
							}, 500);

						});
						$("#public_appearances_create").on('hidden.bs.modal', function (e) {
							$(this).find(".formField").removeClass("formField-error");
							$(this).find(".formField-error-message ").hide();
						});

						//modal publications works
						$("#savebutton_edit-submit--5").prop('onclick',null).off('click');
						$("#savebutton_edit-submit--5").unbind().click(function(event){
							event.preventDefault();
							$(".preloader").show();

							//set timeout to show preloader on safari
							setTimeout(function(){
								if(Drupal.behaviors.formValidation.validateFields($("#savebutton_edit-submit--5").closest(".modal-content"), true)){
									//submit form
									$("#edit-submit--5").click();
								}
								else{
									//found validation error
									$(".preloader").hide();
								}
							}, 500);

						});
						$("#publications_create").on('hidden.bs.modal', function (e) {
							$(this).find(".formField").removeClass("formField-error");
							$(this).find(".formField-error-message ").hide();
						});

						//main form submit
						$("#appliationFormSubmitButton").siblings("button[type='submit']").prop("disabled", true);
						$("#appliationFormSubmitButton").click(function(event){
							event.preventDefault();
							Drupal.behaviors.functions.consolog("#appliationFormSubmitButton CLICK");
							$(".preloader").show();

							setTimeout(function(){
								var validationResult1 = Drupal.behaviors.formValidation.validateFields($("#application-form"), false);
								var validationResult2 = validateSpecialFields($("#application-form"), false);
								Drupal.behaviors.functions.consolog("#application-form-submit validationResult1:" + validationResult1);
								Drupal.behaviors.functions.consolog("#application-form-submit validationResult2:" + validationResult2);

								if(validationResult1 && validationResult2){
									//submit form
									$("#appliationFormSubmitButton").siblings("button[type='submit']").prop("disabled", false);
									$("#appliationFormSubmitButton").siblings("button[type='submit']").click();
								}
								else{
									//scroll to error
									$(".preloader").hide();
									$('html, body').animate({
										scrollTop: $(".formField-error").offset().top-150
									}, 500);
								}

							}, 500);
						});
					}

					function validateSpecialFields($container, ismodal){

						var valid = true;

						//special validation for form of arts
						if(!ismodal && $("#form-of-art").find("input[type='checkbox']:checked").length == 0){
							$("#form-of-art").find(".formField").addClass("formField-error");
							valid = false;
						}

						//special validation for form of arts
						if(!ismodal && $(".artistic_upload.formField-achievements").length == 0){
							$("#label-artistic-work").addClass("formField-error");
							valid = false;
						}

						//group or single
						if(!ismodal && !$("#edit-type-1").prop('checked')){
							Drupal.behaviors.functions.consolog("single");
						}
						else if(!ismodal && !$("#edit-type-0").prop('checked')){
							Drupal.behaviors.functions.consolog("group");
						}

						Drupal.behaviors.functions.consolog("validateSpecialFields() result:" + valid);

						return valid;
					}
				}
			}

	  Drupal.behaviors.applicationFormAchievementsCreator = function (context) {
		var mainContext = context;
		//User Artistic works
		//Get modal to open
		var userArtisticWorksModalDialog = $("#user_artistic_works_create",mainContext);
		$('[data-name="user_update_work"]', mainContext).each(function (index){
			var mainContent = $(this);
			var indexOfElement = $(mainContent).data( "index" );
		    	var isAlreadyModified = $(mainContent).data("achievementbehavior-done");
		    	if(isAlreadyModified){
		    		return true;
		    	}

		    	//Get element for info
		    	var selectedElement = $(".user_artistic_upload[data-index='" + indexOfElement + "']",mainContext);


		    	$(mainContent).click(function(event) {
		    		Drupal.behaviors.functions.consolog("Show modal:" + indexOfElement);
		    		$(userArtisticWorksModalDialog).append('<input class="modalIndexHiddenField" type="hidden" name="index" value="' + indexOfElement + '">');
		    		//Fill the information
		    		//work_type select
		    		//work_identifier text
		    		//work_url text
		    		//work_year select
		    		//work_description multitext
		    		//work_title text
		    		//work_file imageSelector
		    		$("#user_work_type",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-type"));
		    		$("#user_work_type",userArtisticWorksModalDialog).change();
		    		$("#user_work_identifier",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-identifier"));
		    		$("#user_work_url",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-external-url"));

		    		//Make fields invisible according to type
		    		var valueSelected = $(".user_artistic_upload_data",selectedElement).data("work-type");
		    		if(valueSelected == "image"){
		    			$(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).addClass("hideElement");
		    			$(".artisticWork-Option-URL",userArtisticWorksModalDialog).addClass("hideElement");
		    		}else if(valueSelected == "external"){
		    			$(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).addClass("hideElement");
		    			$(".artisticWork-Option-URL",userArtisticWorksModalDialog).removeClass("hideElement");
		    		}else{
		    			$(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).removeClass("hideElement");
		    			$(".artisticWork-Option-URL",userArtisticWorksModalDialog).addClass("hideElement");
		    		}

		    		$("#user_work_year",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-year"));
		    		$("#user_work_year",userArtisticWorksModalDialog).change();
		    		$("#user_work_description",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-description"));
		    		$("#user_work_description",userArtisticWorksModalDialog).change();
		    		$("#user_work_description_zh_hans",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-description-zh-hans"));
		    		$("#user_work_description_zh_hans",userArtisticWorksModalDialog).change();
		    		$("#user_work_title",userArtisticWorksModalDialog).val($(".user_artistic_upload_data",selectedElement).data("work-title"));
		    		//Pass photo url
		    		Drupal.behaviors.setPictureOnPictureLoader($("#user_work_photo_loader",userArtisticWorksModalDialog),$(".user_artistic_upload_data",selectedElement).data("work-file"));
		    		var imageSectionName = $(".user_artistic_upload_data",selectedElement).data("image-section-name");
		    		var imageID = $(".user_artistic_upload_data",selectedElement).data("image-id");

		    		$("#user_work_photo_loader",userArtisticWorksModalDialog).before('<input type="hidden" data-uploaded-picture-name="' + imageSectionName + '" name="' + imageSectionName + '" value="' + imageID + '">');
		    		$(userArtisticWorksModalDialog).modal('show');
		    	});

		    	$(mainContent).data("achievementbehavior-done",true);
	  	});
		//Remove the hidden field when the modal is gone
	    	$(userArtisticWorksModalDialog).on('hidden.bs.modal', function () {
	    		Drupal.behaviors.functions.consolog("Hidden modal:");
	    		//Remove hidden field
	    		$(".modalIndexHiddenField",userArtisticWorksModalDialog).remove();
	    		//Remove the information
	    		$("#user_work_type",userArtisticWorksModalDialog).val("image");
	    		$("#user_work_type",userArtisticWorksModalDialog).change();
	    		$("#user_work_identifier",userArtisticWorksModalDialog).val("");
	    		$("#user_work_url",userArtisticWorksModalDialog).val("");
	    		$("#user_work_year",userArtisticWorksModalDialog).val("");
	    		$("#user_work_year",userArtisticWorksModalDialog).change();
	    		$("#user_work_description",userArtisticWorksModalDialog).val("");
	    		$("#user_work_description",userArtisticWorksModalDialog).change();
	    		$("#user_work_description_zh_hans",userArtisticWorksModalDialog).val("");
	    		$("#user_work_description_zh_hans",userArtisticWorksModalDialog).change();
	    		$("#user_work_title",userArtisticWorksModalDialog).val("");
  			$(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).addClass("hideElement");
			$(".artisticWork-Option-URL",userArtisticWorksModalDialog).addClass("hideElement");
	    		//Empty the photo url
	    		Drupal.behaviors.setPictureOnPictureLoader($("#user_work_photo_loader",userArtisticWorksModalDialog),"");
	    		$("input[data-uploaded-picture-name]",userArtisticWorksModalDialog).remove();
	    		//$("#work_file",artisticWorksModalDialog).val("");
	    	});

	    	//SPECIAL CHECK FOR SELECT BOX IN MODAL
	    	$('#user_work_type',userArtisticWorksModalDialog).change(function() {
	    		var valueSelected = $( "option:selected",this).val();
	    		  if(valueSelected == "image"){
	    			  $(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).addClass("hideElement");
	    			  $(".artisticWork-Option-URL",userArtisticWorksModalDialog).addClass("hideElement");
	    		  }else if(valueSelected == "external"){
	    			  $(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).addClass("hideElement");
	    			  $(".artisticWork-Option-URL",userArtisticWorksModalDialog).removeClass("hideElement");
	    		  }else{
	    			  $(".artisticWork-Option-Identifier",userArtisticWorksModalDialog).removeClass("hideElement");
	    			  $(".artisticWork-Option-URL",userArtisticWorksModalDialog).addClass("hideElement");
	    		  }
	    	});

		//Group Artistic works
		//Get modal to open
		var groupArtisticWorksModalDialog = $("#group_artistic_works_create",mainContext);
		$('[data-name="group_update_work"]', mainContext).each(function (index){
			var mainContent = $(this);
			var indexOfElement = $(mainContent).data( "index" );
		    	var isAlreadyModified = $(mainContent).data("achievementbehavior-done");
		    	if(isAlreadyModified){
		    		return true;
		    	}

		    	//Get element for info
		    	var selectedElement = $(".group_artistic_upload[data-index='" + indexOfElement + "']",mainContext);


		    	$(mainContent).click(function(event) {
		    		Drupal.behaviors.functions.consolog("Show modal:" + indexOfElement);
		    		$(groupArtisticWorksModalDialog).append('<input class="modalIndexHiddenField" type="hidden" name="index" value="' + indexOfElement + '">');
		    		//Fill the information
		    		//work_type select
		    		//work_identifier text
		    		//work_url text
		    		//work_year select
		    		//work_description multitext
		    		//work_title text
		    		//work_file imageSelector
		    		$("#group_work_type",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-type"));
		    		$("#group_work_type",groupArtisticWorksModalDialog).change();
		    		$("#group_work_identifier",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-identifier"));
		    		$("#group_work_url",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-external-url"));

		    		//Make fields invisible according to type
		    		var valueSelected = $(".group_artistic_upload_data",selectedElement).data("work-type");
		    		if(valueSelected == "image"){
		    			$(".artisticWork-Option-Identifier",groupArtisticWorksModalDialog).addClass("hideElement");
		    			$(".artisticWork-Option-URL",groupArtisticWorksModalDialog).addClass("hideElement");
		    		}else if(valueSelected == "external"){
		    			$(".artisticWork-Option-Identifier",groupArtisticWorksModalDialog).addClass("hideElement");
		    			$(".artisticWork-Option-URL",groupArtisticWorksModalDialog).removeClass("hideElement");
		    		}else{
		    			$(".artisticWork-Option-Identifier",groupArtisticWorksModalDialog).removeClass("hideElement");
		    			$(".artisticWork-Option-URL",groupArtisticWorksModalDialog).addClass("hideElement");
		    		}
		    		$("#group_work_year",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-year"));
		    		$("#group_work_year",groupArtisticWorksModalDialog).change();
		    		$("#group_work_description",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-description"));
		    		$("#group_work_description",groupArtisticWorksModalDialog).change();
		    		$("#group_work_description_zh_hans",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-description-zh-hans"));
		    		$("#group_work_description_zh_hans",groupArtisticWorksModalDialog).change();
		    		$("#group_work_title",groupArtisticWorksModalDialog).val($(".group_artistic_upload_data",selectedElement).data("work-title"));
		    		//Pass photo url
		    		Drupal.behaviors.setPictureOnPictureLoader($("#group_work_photo_loader",groupArtisticWorksModalDialog),$(".group_artistic_upload_data",selectedElement).data("work-file"));
		    		var imageSectionName = $(".group_artistic_upload_data",selectedElement).data("image-section-name");
		    		var imageID = $(".group_artistic_upload_data",selectedElement).data("image-id");

		    		$("#group_work_photo_loader",groupArtisticWorksModalDialog).before('<input type="hidden" data-uploaded-picture-name="' + imageSectionName + '" name="' + imageSectionName + '" value="' + imageID + '">');
		    		$(groupArtisticWorksModalDialog).modal('show');
		    	});

		    	$(mainContent).data("achievementbehavior-done",true);
	  	});
		//Remove the hidden field when the modal is gone
	    	$(groupArtisticWorksModalDialog).on('hidden.bs.modal', function () {
	    		Drupal.behaviors.functions.consolog("Hidden modal:");
	    		//Remove hidden field
	    		$(".modalIndexHiddenField",groupArtisticWorksModalDialog).remove();
	    		//Remove the information
	    		$("#group_work_type",groupArtisticWorksModalDialog).val("image");
	    		$("#group_work_type",groupArtisticWorksModalDialog).change();
	    		$("#group_work_identifier",groupArtisticWorksModalDialog).val("");
	    		$("#group_work_url",groupArtisticWorksModalDialog).val("");
	    		$("#group_work_year",groupArtisticWorksModalDialog).val("");
	    		$("#group_work_year",groupArtisticWorksModalDialog).change();
	    		$("#group_work_description",groupArtisticWorksModalDialog).val("");
	    		$("#group_work_description",groupArtisticWorksModalDialog).change();
	    		$("#group_work_description_zh_hans",groupArtisticWorksModalDialog).val("");
	    		$("#group_work_description_zh_hans",groupArtisticWorksModalDialog).change();
	    		$("#group_work_title",groupArtisticWorksModalDialog).val("");
	    		//Empty the photo url
	    		Drupal.behaviors.setPictureOnPictureLoader($("#group_work_photo_loader",groupArtisticWorksModalDialog),"");
	    		$("input[data-uploaded-picture-name]",groupArtisticWorksModalDialog).remove();
	    		//$("#work_file",artisticWorksModalDialog).val("");
	    	});
	    	//SPECIAL CHECK FOR SELECT BOX IN MODAL
	    	$('#group_work_type',groupArtisticWorksModalDialog).change(function() {
	    		var valueSelected = $( "option:selected",this).val();
	    		  if(valueSelected == "image"){
	    			  $(".artisticWork-Option-Identifier",groupArtisticWorksModalDialog).addClass("hideElement");
	    			  $(".artisticWork-Option-URL",groupArtisticWorksModalDialog).addClass("hideElement");
	    		  }else if(valueSelected == "external"){
	    			  $(".artisticWork-Option-Identifier",groupArtisticWorksModalDialog).addClass("hideElement");
	    			  $(".artisticWork-Option-URL",groupArtisticWorksModalDialog).removeClass("hideElement");
	    		  }else{
	    			  $(".artisticWork-Option-Identifier",groupArtisticWorksModalDialog).removeClass("hideElement");
	    			  $(".artisticWork-Option-URL",groupArtisticWorksModalDialog).addClass("hideElement");
	    		  }
	    	});


		//Individual Artistic works
		//Get modal to open
		var artisticWorksModalDialog = $("#artistic_works_create",mainContext);
		$('[data-name="update_work"]', mainContext).each(function (index){
			var mainContent = $(this);
			var indexOfElement = $(mainContent).data( "index" );
		    	var isAlreadyModified = $(mainContent).data("achievementbehavior-done");
		    	if(isAlreadyModified){
		    		return true;
		    	}

		    	//Get element for info
		    	var selectedElement = $(".artistic_upload",mainContext)[indexOfElement];


		    	$(mainContent).click(function(event) {
		    		Drupal.behaviors.functions.consolog("Show modal:" + indexOfElement);
		    		$(artisticWorksModalDialog).append('<input class="modalIndexHiddenField" type="hidden" name="index" value="' + indexOfElement + '">');
		    		//Fill the information
		    		//work_year select
		    		//work_description multitext
		    		//work_title text
		    		//work_file imageSelector
		    		$("#work_year",artisticWorksModalDialog).val($(".artistic_upload_data",selectedElement).data("work-year"));
		    		$("#work_year",artisticWorksModalDialog).change();
		    		$("#work_description",artisticWorksModalDialog).val($(".artistic_upload_data",selectedElement).data("work-description"));
		    		$("#work_description",artisticWorksModalDialog).change();
		    		$("#work_dimension",artisticWorksModalDialog).val($(".artistic_upload_data",selectedElement).data("work-dimension"));
		    		$("#work_dimension",artisticWorksModalDialog).change();
		    		$("#work_title",artisticWorksModalDialog).val($(".artistic_upload_data",selectedElement).data("work-title"));
		    		//Pass photo url
		    		Drupal.behaviors.setPictureOnPictureLoader($("#work_photo_loader",artisticWorksModalDialog),$(".artistic_upload_data",selectedElement).data("work-file"));
		    		var imageSectionName = $(".artistic_upload_data",selectedElement).data("image-section-name");
		    		var imageID = $(".artistic_upload_data",selectedElement).data("image-id");

		    		$("#work_photo_loader",artisticWorksModalDialog).before('<input type="hidden" data-uploaded-picture-name="' + imageSectionName + '" name="' + imageSectionName + '" value="' + imageID + '">');
		    		$(artisticWorksModalDialog).modal('show');
		    	});

		    	$(mainContent).data("achievementbehavior-done",true);
	  	});
		//Remove the hidden field when the modal is gone
	    	$(artisticWorksModalDialog).on('hidden.bs.modal', function () {
	    		Drupal.behaviors.functions.consolog("Hidden modal:");
	    		//Remove hidden field
	    		$(".modalIndexHiddenField",artisticWorksModalDialog).remove();
	    		//Remove the information
	    		$("#work_year",artisticWorksModalDialog).val("");
	    		$("#work_year",artisticWorksModalDialog).change();
	    		$("#work_description",artisticWorksModalDialog).val("");
	    		$("#work_description",artisticWorksModalDialog).change();
	    		$("#work_dimension",artisticWorksModalDialog).val("");
	    		$("#work_dimension",artisticWorksModalDialog).change();
	    		$("#work_title",artisticWorksModalDialog).val("");
	    		//Empty the photo url
	    		Drupal.behaviors.setPictureOnPictureLoader($("#work_photo_loader",artisticWorksModalDialog),"");
	    		$("input[data-uploaded-picture-name]",artisticWorksModalDialog).remove();
	    		//$("#work_file",artisticWorksModalDialog).val("");
	    	});

		//Qualifications and Awards
		//Get modal to open
		var awardsModalDialog = $("#qualifications_awards_create",mainContext);
		$('[data-name="update_award"]', mainContext).each(function (index){
			var mainContent = $(this);
			var indexOfElement = $(mainContent).data( "index" );
		    	var isAlreadyModified = $(mainContent).data("awardbehavior-done");
		    	if(isAlreadyModified){
		    		return true;
		    	}

		    	//Get element for info
		    	var selectedElement = $(".awards_upload",mainContext)[indexOfElement];


		    	$(mainContent).click(function(event) {
		    		Drupal.behaviors.functions.consolog("Show modal:" + indexOfElement);
		    		$(awardsModalDialog).append('<input class="modalIndexHiddenField" type="hidden" name="index" value="' + indexOfElement + '">');
		    		//Fill the information
		    		//award_year select
		    		//award_organisation text
		    		//award_title text
		    		//award_country select
		    		$("#award_year",awardsModalDialog).val($(".awards_upload_data",selectedElement).data("award-year"));
		    		$("#award_year",awardsModalDialog).change();
		    		$("#award_organisation",awardsModalDialog).val($(".awards_upload_data",selectedElement).data("award-organisation"));
		    		$("#award_title",awardsModalDialog).val($(".awards_upload_data",selectedElement).data("award-title"));
		    		$("#award_country",awardsModalDialog).val($(".awards_upload_data",selectedElement).data("award-country"));
		    		$("#award_country",awardsModalDialog).change();
		    		$(awardsModalDialog).modal('show');
		    	});

		    	$(mainContent).data("awardbehavior-done",true);
	  	});
		//Remove the hidden field when the modal is gone
	    	$(awardsModalDialog).on('hidden.bs.modal', function () {
	    		Drupal.behaviors.functions.consolog("Hidden modal:");
	    		//Remove hidden field
	    		$(".modalIndexHiddenField",awardsModalDialog).remove();
	    		//Remove the information
	    		$("#award_year",awardsModalDialog).val("");
	    		$("#award_year",awardsModalDialog).change();
	    		$("#award_organisation",awardsModalDialog).val("");
	    		$("#award_title",awardsModalDialog).val("");
	    		$("#award_country",awardsModalDialog).val("");
	    		$("#award_country",awardsModalDialog).change();
	    	});

		//Public appearances
		//Get modal to open
		var appearancesModalDialog = $("#public_appearances_create",mainContext);
		$('[data-name="update_appearance"]', mainContext).each(function (index){
			var mainContent = $(this);
			var indexOfElement = $(mainContent).data( "index" );
		    	var isAlreadyModified = $(mainContent).data("appearancebehavior-done");
		    	if(isAlreadyModified){
		    		return true;
		    	}

		    	//Get element for info
		    	var selectedElement = $(".appearances_upload",mainContext)[indexOfElement];


		    	$(mainContent).click(function(event) {
		    		Drupal.behaviors.functions.consolog("Show modal:" + indexOfElement);
		    		$(appearancesModalDialog).append('<input class="modalIndexHiddenField" type="hidden" name="index" value="' + indexOfElement + '">');
		    		//Fill the information
		    		//appearance_year select
		    		//appearance_type select
		    		//appearance_city text
		    		//appearance_title text
		    		//appearance_venue text
		    		//appearance_country select
		    		$("#appearance_year",appearancesModalDialog).val($(".appearances_upload_data",selectedElement).data("appearance-year"));
		    		$("#appearance_year",appearancesModalDialog).change();
		    		$("#appearance_type",appearancesModalDialog).val($(".appearances_upload_data",selectedElement).data("appearance-type"));
		    		$("#appearance_type",appearancesModalDialog).change();
		    		$("#appearance_city",appearancesModalDialog).val($(".appearances_upload_data",selectedElement).data("appearance-city"));
		    		$("#appearance_title",appearancesModalDialog).val($(".appearances_upload_data",selectedElement).data("appearance-title"));
		    		$("#appearance_venue",appearancesModalDialog).val($(".appearances_upload_data",selectedElement).data("appearance-venue"));
		    		$("#appearance_country",appearancesModalDialog).val($(".appearances_upload_data",selectedElement).data("appearance-country"));
		    		$("#appearance_country",appearancesModalDialog).change();
                    Drupal.behaviors.setPictureOnPictureLoader($("#appearance_doc_loader",appearancesModalDialog),$(".appearances_upload_data",selectedElement).data("appearance-file"));
                    var imageSectionName = $(".appearances_upload_data",selectedElement).data("image-section-name");
                    var imageID = $(".appearances_upload_data",selectedElement).data("image-id");
                    if(imageID){
                        $("#appearance_doc_loader",appearancesModalDialog).before('<input type="hidden" data-uploaded-picture-name="' + imageSectionName + '" name="' + imageSectionName + '" value="' + imageID + '">');
                    }
		    		$(appearancesModalDialog).modal('show');
		    	});

		    	$(mainContent).data("appearancebehavior-done",true);
	  	});
		//Remove the hidden field when the modal is gone
	    	$(appearancesModalDialog).on('hidden.bs.modal', function () {
	    		Drupal.behaviors.functions.consolog("Hidden modal:");
	    		//Remove hidden field
	    		$(".modalIndexHiddenField",appearancesModalDialog).remove();
	    		//Remove the information
	    		$("#appearance_year",appearancesModalDialog).val("");
	    		$("#appearance_year",appearancesModalDialog).change();
	    		$("#appearance_type",appearancesModalDialog).val("");
	    		$("#appearance_type",appearancesModalDialog).change();
	    		$("#appearance_city",appearancesModalDialog).val("");
	    		$("#appearance_title",appearancesModalDialog).val("");
	    		$("#appearance_venue",appearancesModalDialog).val("");
	    		$("#appearance_country",appearancesModalDialog).val("");
	    		$("#appearance_country",appearancesModalDialog).change();
                Drupal.behaviors.setPictureOnPictureLoader($("#appearance_doc_loader",appearancesModalDialog),"");
                $("input[data-uploaded-picture-name]",appearancesModalDialog).remove();
	    	});

		//Publications
		//Get modal to open
		var publicationsModalDialog = $("#publications_create",mainContext);
		$('[data-name="update_publication"]', mainContext).each(function (index){
			var mainContent = $(this);
			var indexOfElement = $(mainContent).data( "index" );
		    	var isAlreadyModified = $(mainContent).data("publicationbehavior-done");
		    	if(isAlreadyModified){
		    		return true;
		    	}

		    	//Get element for info
		    	var selectedElement = $(".publications_upload",mainContext)[indexOfElement];


		    	$(mainContent).click(function(event) {
		    		Drupal.behaviors.functions.consolog("Show modal:" + indexOfElement);
		    		$(publicationsModalDialog).append('<input class="modalIndexHiddenField" type="hidden" name="index" value="' + indexOfElement + '">');
		    		//Fill the information
		    		//publication_year select
		    		//publication_type select
		    		//publication_publisher select
		    		//publication_title text
		    		//publication_author text
		    		//publication_country select
		    		$("#publication_year",publicationsModalDialog).val($(".publications_upload_data",selectedElement).data("publication-year"));
		    		$("#publication_year",publicationsModalDialog).change();
		    		$("#publication_type",publicationsModalDialog).val($(".publications_upload_data",selectedElement).data("publication-type"));
		    		$("#publication_type",publicationsModalDialog).change();
		    		$("#publication_publisher",publicationsModalDialog).val($(".publications_upload_data",selectedElement).data("publication-publisher"));
		    		$("#publication_publisher",publicationsModalDialog).change();
		    		$("#publication_title",publicationsModalDialog).val($(".publications_upload_data",selectedElement).data("publication-title"));
		    		$("#publication_author",publicationsModalDialog).val($(".publications_upload_data",selectedElement).data("publication-author"));
		    		$("#publication_country",publicationsModalDialog).val($(".publications_upload_data",selectedElement).data("publication-country"));
		    		$("#publication_country",publicationsModalDialog).change();
		    		$(publicationsModalDialog).modal('show');
		    	});

		    	$(mainContent).data("publicationbehavior-done",true);
	  	});
		//Remove the hidden field when the modal is gone
	    	$(publicationsModalDialog).on('hidden.bs.modal', function () {
	    		Drupal.behaviors.functions.consolog("Hidden modal:");
	    		//Remove hidden field
	    		$(".modalIndexHiddenField",publicationsModalDialog).remove();
	    		//Remove the information
	    		$("#publication_year",publicationsModalDialog).val("");
	    		$("#publication_year",publicationsModalDialog).change();
	    		$("#publication_type",publicationsModalDialog).val("");
	    		$("#publication_type",publicationsModalDialog).change();
	    		$("#publication_publisher",publicationsModalDialog).val("");
	    		$("#publication_publisher",publicationsModalDialog).change();
	    		$("#publication_title",publicationsModalDialog).val("");
	    		$("#publication_author",publicationsModalDialog).val("");
	    		$("#publication_country",publicationsModalDialog).val("");
	    		$("#publication_country",publicationsModalDialog).change();
	    	});
	  }

})(jQuery);
